// extracted by mini-css-extract-plugin
export var cardHeader = "_e6-0";
export var reorderHandle = "_e6-3";
export var titleArea = "_e6-1";
export var titleAreaWithHandle = "_e6-2";